import { useTranslation } from "next-i18next";
import styles from "./strike.module.scss";

const Strike = (props) => {
  const { background = "ffffff" } = props;
  const { t } = useTranslation("common");
  return (
    <div className={styles.strike_container}>
      <span style={{ backgroundColor: background }} className={styles.strike_text}>{t("or")}</span>
    </div>
  );
};
export default Strike;
